import { indexLoaded } from "@/indexLoaded";

indexLoaded();
